import { Typography } from 'antd'
import { observer } from 'mobx-react-lite'

import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'
import { formatDateUk } from '@/Ship/Helpers/fieldViews'

import { CrmChildListTab } from '../ChildList/CrmChildListTab'
import { CRM_CONTRACT_FIELD_LABELS as L } from './CrmContract'

import type { CrmOwnerFormContextLike } from '../Owner/CrmOwnerFormContext'
import type { CrmContractRow } from './CrmContract'
import type { TableColumnsType } from 'antd'

const { Text } = Typography

const dash = <Text type="secondary">—</Text>

/** Колонки — як у легасі (`ClientContractCrud.jsx:29`): номер, дата, експедитор. */
const COLUMNS: TableColumnsType<CrmContractRow> = [
    {
        title: L.number,
        key: 'number',
        dataIndex: 'number',
        render: (value: unknown) => (typeof value === 'string' && value !== '' ? value : dash),
    },
    {
        title: L.date,
        key: 'date',
        dataIndex: 'date',
        render: (value: unknown) => (value ? formatDateUk(value) : dash),
    },
    {
        title: L.forwarder,
        key: 'forwarder',
        dataIndex: 'forwarder',
        render: (value: CrmContractRow['forwarder']) => value?.title || dash,
    },
]

export interface CrmContractsTabProps {
    /** Ключ ресурсу договору: `Crm.ClientContract` */
    resource: string
    /** Колекція договорів: `/services/client_contracts` */
    restUrl: string
    /** Поле власника в договорі: `client`, `carrier` */
    ownerField: string
    /** `formContext` картки власника */
    ownerFormContext: CrmOwnerFormContextLike | undefined
}

/**
 * Вкладка «Договори» картки власника CRM (`SPEC-008` §7.1, `SPEC-009` §8.4).
 *
 * «Додати договір» — за **колекційним** правом `create` ресурсу договору
 * (`CheckGlobalResourceAccessTask`), а не за `update` власника: договори
 * веде бухгалтер, який клієнта не редагує (`SPEC-003` §2.4). Змінити й
 * видалити — `_permissions` рядка.
 */
export const CrmContractsTab = observer(({ resource, restUrl, ownerField, ownerFormContext }: CrmContractsTabProps) => (
    <CrmChildListTab<CrmContractRow>
        resource={resource}
        restUrl={restUrl}
        ownerField={ownerField}
        ownerFormContext={ownerFormContext}
        canAdd={CheckGlobalResourceAccessTask(resource, 'create')}
        columns={COLUMNS}
        texts={{
            add: 'Додати договір',
            empty: 'Договорів ще немає.',
            loadFailed: 'Не вдалося завантажити договори.',
            removeTitle: 'Видалити договір?',
            removeDescription: 'Договір зникне зі списку договорів.',
            removeLabel: 'Видалити договір',
            countNoun: 'договорів',
        }}
    />
))
